import { PageContent } from '@core/ui';
import { TableProvider } from '@core/table';

import { CountriesTableContext } from '../contexts';
import { useCountriesTableContext } from '../hooks';
import { CountriesActionBar } from '../containers/countries-action-bar';
import { CountriesTable } from '../containers/countries-table';

export const CountriesPage = () => {
  const { onFetch } = useCountriesTableContext();

  return (
    <TableProvider name='countries' context={CountriesTableContext} onFetch={onFetch}>
      <PageContent $contain={true}>
        <CountriesActionBar />
        <CountriesTable />
      </PageContent>
    </TableProvider>
  );
};
